import { useIntl } from "react-intl";

import {
  boardBasisMessages,
  isKnownBoardBasis,
} from "@/features/hotels/utils/boardBasis";

type Props = {
  boardBasis: string;
};

export const BoardBasisName = ({ boardBasis }: Props) => {
  const intl = useIntl();

  return isKnownBoardBasis(boardBasis)
    ? intl.formatMessage(boardBasisMessages[boardBasis])
    : boardBasis;
};
